// SEO META
export const SEO_SITEURL = "https://topvalue.com"

// Sitemap
export const SITE_DEFAULT_PAGESIZE = 100;